/**
 * WNBA player ID map (name -> WNBA.com PERSON_ID) for headshot URL resolution.
 *
 * Hardcoded fallback so WNBA headshots keep working when the live fetch in
 * server/services/nbaPlayerIdService.ts (cdn.wnba.com player index) fails and
 * would otherwise cache an empty map. Mirrors the role of NBA_PLAYER_IDS.
 *
 * Snapshot of cdn.wnba.com/static/json/staticData/playerIndex.json captured
 * 2026-07-28 (226 players). Regenerate via scripts/generate-player-headshot-map.ts.
 * The live fetch, when it succeeds, is layered on top of this base.
 */
export const WNBA_PLAYER_IDS: Record<string, number> = {
  "A'ja Wilson": 1628932,
  'Aaliyah Edwards': 1642290,
  'Aaliyah Nye': 1642801,
  'Aicha Coulibaly': 1642786,
  'Alanna Smith': 1629501,
  'Alex Fowler': 1643525,
  'Alex Wilson': 1642775,
  'Alicia Florez': 1643644,
  'Alissa Pili': 1642293,
  'Aliyah Boston': 1641648,
  'Allisha Gray': 1628277,
  'Alysha Clark': 202252,
  'Alyssa Thomas': 203826,
  'Amy Okonkwo': 1629539,
  'Anastasiia Olairi Kosu': 1642797,
  'Aneesah Morrow': 1642800,
  'Angel Reese': 1642291,
  'Angela Dugalic': 1643455,
  'Anneli Maley': 1630993,
  'Antonia Delaere': 1643489,
  'Ariel Atkins': 1628878,
  'Arike Ogunbowale': 1629481,
  'Ashlon Jackson': 1643437,
  'Ashten Prechtel': 1641695,
  'Aubrey Griffin': 1642826,
  'Awa Fam': 1643443,
  'Awak Kuier': 1630386,
  'Aziaha James': 1642793,
  'Azura Stevens': 1628922,
  'Azzi Fudd': 1643425,
  'Betnijah Laney-Hamilton': 204335,
  'Breanna Stewart': 1627668,
  'Bree Hall': 1642788,
  'Brianna Turner': 1629488,
  'Bridget Carleton': 1629524,
  'Brionna Jones': 1628280,
  'Brittney Griner': 203398,
  'Brittney Sykes': 1628279,
  'Caitlin Clark': 1642286,
  'Cameron Brink': 1642287,
  'Carla Leite': 1642304,
  'Cassandre Prosper': 1643467,
  'Cecilia Zandalasini': 1628508,
  'Chance Gray': 1643462,
  'Charlisse Leger-Walker': 1643449,
  'Chelsea Gray': 203833,
  'Chennedy Carter': 1630150,
  'Cheyenne Parker-Tyus': 204323,
  'Chloe Bibby': 1631064,
  'Costanza Verona': 1643424,
  'Cotie McMahon': 1643430,
  'Courtney Vandersloot': 202664,
  'Courtney Williams': 1627675,
  'Damiris Dantas': 203024,
  'Dana Evans': 1630389,
  'Darianna Littlepage-Buggs': 1643440,
  'Dearica Hamby': 204324,
  'DeWanna Bonner': 201886,
  'Diamond Miller': 1641649,
  'DiJonai Carrington': 1630096,
  'Dominique Malonga': 1642798,
  'Dorka Juhasz': 1641657,
  'Eliska Hamzova': 1643490,
  'Elizabeth Williams': 204322,
  'Emese Hof': 1629581,
  'Emily Engstler': 1631083,
  'Emma Cannon': 1628242,
  'Emma Cechova': 1643488,
  'Erica Wheeler': 204365,
  'Ezi Magbegor': 1629496,
  "Flau'jae Johnson": 1643428,
  'Frieda Buhner': 1643494,
  'Gabby Williams': 1628931,
  'Gabriela Jaquez': 1643447,
  'Georgia Amoore': 1642781,
  'Gianna Kneepkens': 1643429,
  'Grace VanSlooten': 1643453,
  'Hailey Van Lith': 1642817,
  'Haley Jones': 1641650,
  'Han Xu': 1629566,
  'Holly Winterburn': 1641683,
  'Iliana Rupert': 1630387,
  'Indya Nivar': 1643469,
  'Isabelle Harrison': 204330,
  'Isobel Borlase': 1642302,
  'Jackie Young': 1629498,
  'Jacy Sheldon': 1642292,
  'Jade Melbourne': 1631141,
  'Janelle Salaun': 1642767,
  'Jaylyn Sherrod': 1642320,
  'Jessica Shepard': 1629491,
  'Jewell Loyd': 204319,
  'Jihyun Park': 1630148,
  'JJ Quinerly': 1642808,
  'Jonquel Jones': 1627673,
  'Jordan Harrison': 1643527,
  'Jordan Horston': 1641651,
  'Jordin Canada': 1628886,
  'Jovana Nogic': 1643505,
  'Joyner Holmes': 1630115,
  'Julie Allemand': 1627700,
  'Julie Vanloo': 1642210,
  'Juste Jocyte': 1642794,
  'Justine Pissott': 1643495,
  'Kahleah Copper': 1627674,
  'Kaila Charles': 1630097,
  'Kaitlyn Chen': 1642822,
  'Kamiah Smalls': 1630154,
  'Kamilla Cardoso': 1642289,
  'Kara Dunn': 1643454,
  'Karlie Samuelson': 1628317,
  'Kate Martin': 1642324,
  'Katie Lou Samuelson': 1629478,
  'Kayla Alexander': 203405,
  'Kayla McBride': 203825,
  'Kayla Thornton': 203866,
  'Kelsey Mitchell': 1628909,
  'Kelsey Plum': 1628276,
  'Kennedy Burke': 1629568,
  'Kia Nurse': 1628915,
  'Kiah Stokes': 204329,
  'Kiana Williams': 1630461,
  'Kierstan Bell': 1631006,
  'Kiki Iriafen': 1642792,
  'Kiki Rice': 1643445,
  'Kyara Linskens': 1642768,
  'Laeticia Amihere': 1641656,
  'Laura Juskaite': 1643420,
  'Laura Ziegler': 1643461,
  'Lauren Betts': 1643427,
  'Leila Lacan': 1642303,
  'Leonie Fiebich': 1630142,
  'Lexi Held': 1631118,
  'Lexie Brown': 1628882,
  'Lexie Hull': 1631086,
  'Li Yueru': 1629574,
  'Liatu King': 1642820,
  'Lucy Olsen': 1642802,
  'Luisa Geiselsoder': 1630143,
  'Mackenzie Holmes': 1642307,
  'Maddy Siegrist': 1641652,
  'Maddy Westbeld': 1642818,
  'Madina Okot': 1643431,
  'Mai Yamamoto': 1642769,
  'Makayla Timpson': 1642815,
  'Maria Conde': 1629576,
  'Mariella Fasoula': 1630108,
  'Marina Mabrey': 1629497,
  'Marine Fauthoux': 1630469,
  'Marine Johannes': 1629546,
  'Marta Suarez': 1643438,
  'Maya Caldwell': 1630471,
  'Megan DiLeo': 1629484,
  'Michaela Onyenwere': 1630446,
  'Miela Sowah': 1631039,
  'Monique Akoa Makani': 1642777,
  'Monique Billings': 1628881,
  'Myisha Hines-Allen': 1628899,
  'Nadia Fingall': 1643686,
  'NaLyssa Smith': 1631019,
  'Napheesa Collier': 1629483,
  'Natasha Cloud': 204333,
  'Natasha Howard': 203827,
  'Natasha Mack': 1630442,
  'Natisha Hiedeman': 1629567,
  'Naz Hillmon': 1631044,
  'Ndjakalenga Mwenentanda': 1643479,
  'Nell Angloma': 1643448,
  'Nia Coffey': 1628269,
  'Nikolina Milic': 1631263,
  'Nneka Ogwumike': 203014,
  'Noemie Brochant': 1643493,
  'Nyadiew Puoch': 1642296,
  'Nyara Sabally': 1631055,
  'Odyssey Sims': 203824,
  'Olivia Miles': 1643426,
  'Olivia Nelson-Ododa': 1631135,
  'Ornella Bankole': 1643706,
  'Paige Bueckers': 1642784,
  'Pauline Astier': 1631136,
  'Peyton Williams': 1630138,
  'Quionche Carter': 1643487,
  'Rachel Banham': 1627671,
  'Rae Burrell': 1630996,
  'Raegan Beers': 1643441,
  'Raquel Carrera': 1630384,
  'Raven Johnson': 1643433,
  'Rebecca Allen': 204296,
  'Rebekah Gardner': 203822,
  'Rhyne Howard': 1631009,
  'Rickea Jackson': 1642288,
  'Rori Harmon': 1643450,
  'Sabrina Ionescu': 1629477,
  'Sami Whitcomb': 1628244,
  'Sania Feagin': 1642790,
  'Saniya Rivers': 1642809,
  'Sarah Ashlee Barker': 1642782,
  'Satou Sabally': 1630149,
  'Saylor Poffenbarger': 1643458,
  'Serah Williams': 1643436,
  'Shakira Austin': 1631022,
  'Shatori Walker-Kimbrough': 1628278,
  'Shay Ciezki': 1643470,
  'Sika Kone': 1631021,
  'Skylar Diggins': 203400,
  'Sonia Citron': 1642785,
  'Sophie Cunningham': 1629482,
  'Stefanie Dolson': 203828,
  'Stephanie Talbot': 203855,
  'Sug Sutton': 1630134,
  'Sydney Taylor': 1642321,
  "Ta'Niya Latson": 1643444,
  'Taina Mair': 1643473,
  'Taylor Thierry': 1642814,
  'Te-Hina Paopao': 1642804,
  'Teaira McCowan': 1629479,
  'Teja Oblak': 1643506,
  'Temi Fagbenle': 1627701,
  'Teonni Key': 1643457,
  'Tiffany Hayes': 203026,
  'Tima Pouye': 1643647,
  'Tonie Morgan': 1643439,
  'Tyasha Harris': 1630112,
  'Valeriane Ayayi': 204468,
  'Veronica Burton': 1631007,
  'Zia Cooke': 1641660,
};
